<template>
  <div class="my_radio_layer m-lr-11 c-custom_my_radio_layer">
    <div class="func_panel_item_wrap panel_item_radio">
      <p class="tips_left">
        <el-popover
          v-if="iconIsShow == 'left'"
          placement="top-start"
          :popper-class="`popover_style my-popover custom_popover_style_${$store.state.app.web_language_wm}`"
          :width="tipsWidth"
          trigger="hover"
          :content="tips"
          transition="zoom"
        >
          <span
            class="icon_info"
            slot="reference"
          >?</span>
        </el-popover>
      </p>
      <p
        v-if="title"
        class="panel_item_title title"
        :class="iconIsShow != 'left' ? 'no_icon': ''"
        :style="{
          width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth
        }"
      >
        <span v-text="title"></span>
      </p>

      <p class="panel_item_content">
        <el-radio-group v-model="select_value" :disabled="radioGroupDisabled" >
          <span v-if="option.length == 0 && !notUseDefault">
            <el-radio
              label="default"
              :disabled="defaultIsDisabled == 'true' ? true : false"
              v-if="defaultIsShow == 'true'"
            >{{ defaultTitle || $t('view_back_top_edit_103') }}</el-radio>
            <el-radio
              label="hidden"
              :disabled="hiddenIsDisabled == 'true' ? true : false"
              v-if="hiddenIsShow == 'true'"
            >{{ hiddenTitle || $t('view_back_top_index_105') }}</el-radio>
            <el-radio
              class="self_radio"
              label="custom"
              :disabled="selfIsDisabled == 'true' ? true : false"
              v-if="selfIsShow == 'true'"
            >{{ selfTitle || $t('view_back_top_edit_102') }}</el-radio>
          </span>
          <span v-if="option.length > 0 || notUseDefault">
            <el-radio
              v-for="(item,index) in option"
              :key="index"
              :label="item.value"
              :title="$t(item.label)"
              v-if="item.show !==undefined ? item.show == 'true' ? true: false : true"
              :disabled="item.disabled !== undefined ? item.disabled == 'true' ? true: false : false"
            >{{ $t(item.label) }}</el-radio>
          </span>
          <el-popover
            v-if="iconIsShow == 'right'"
            placement="top-start"
            popper-class="popover_style"
            :width="tipsWidth"
            trigger="hover"
            :content="tips"
            transition="zoom"
          >
            <span
              class="icon_info icon_info_right"
              slot="reference"
            >?</span>
          </el-popover>
        </el-radio-group>
        <span v-if="option.length == 0 && notUseDefault" style="color:#303133">{{$t('widgets_basic_article_list_index_416')}}</span>
      </p>
    </div>

    <div
      v-if="select_value == 'custom'"
      class="pull_down_content"
    >
      <slot name="pull_down_control"></slot>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_radio_index',
  props: {
    radioGroupDisabled: {
      type: Boolean,
      default: false
    },
    notUseDefault: {
       type: Boolean,
      default: false
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    titleWidth: {
      type: String,
      default: '40'
    },
    selectValue: { // 选中的值
      default: 'default'
    },
    iconIsShow: { // 图标位置（'' 不显示 left 左边显示 right 右边显示）
      type: String,
      default: ''
    },
    option: { // 数组
      type: Array,
      default: function () {
        return []
      }
    },
    tips: { // 图标提示信息
      type: String,
      default: ''
    },
    defaultIsShow: { // 默认设置是否显示
      type: String,
      default: 'true'
    },
    hiddenIsShow: { // 隐藏设置是否显示
      type: String,
      default: 'true'
    },
    selfIsShow: { // 自定义设置是否显示
      type: String,
      default: 'true'
    },
    defaultTitle: { // 默认设置标题
      type: String,
      default: ''
    },
    hiddenTitle: { // 隐藏设置标题
      type: String,
      default: ''
    },
    selfTitle: { // 自定义设置标题
      type: String,
      default: ''
    },
    defaultIsDisabled: { // 默认设置是否禁用
      type: String,
      default: 'false'
    },
    hiddenIsDisabled: { // 隐藏设置是否禁用
      type: String,
      default: 'false'
    },
    selfIsDisabled: { // 自定义设置是否禁用
      type: String,
      default: 'false'
    },
    tipsWidth: {
      type: String,
      default: '220'
    }
  },
  data() {
    return {
      select_value: this.selectValue,
    }
  },
  mounted() {
  },
  watch: {
    select_value(val, oldVal) { // 数据双向绑定
      this.$emit('update:selectValue', val);
      this.$emit('change', val);

      //如果选择的是默认，则跑出一个属于默认的事件
      if (val === 'default') {
        this.$emit('default', val);
      }
    },
    'selectValue'(val) { // 数据双向绑定
      this.select_value = val
    },
    'option': { handler: function (n) {
      console.log(n, 'ddd')
    }}
  },
  computed: {},
  methods: {}
}
</script>

<style scoped lang="scss">
.my_radio_layer {
  position: relative;
  margin: 0px 0px 12px 11px;
  .panel_item_title {
    >span{
      white-space: nowrap;
    }
  }
  .tips_left {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 34px;
    position: absolute;
    margin-left: -20px;

    .icon_info {
      border: 1px solid #cfd3db;
      color: #cfd3db;
      width: 18px;
      font-size: 13px;
      height: 18px;
      display: inline-block;
      border-radius: 50%;
      text-align: center;
      line-height: 18px;
      cursor: pointer;
    }

    .icon_info_right {
      margin-left: -10px;
    }
  }

  // &.c-custom_my_radio_layer {
  //   .panel_item_title,.title {
  //     width: auto !important;
  //   }
  // }
}

.popover_style {
  word-break: break-word;
}
</style>
<style>
.my-popover {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/my_radio/index.vue